// © Microsoft Corporation. All rights reserved.

import { DesignSystem, isDarkMode } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../../../utils/enums";
import { neutralLayerCard } from "@microsoft/fast-components-styles-msft";

export const ProfileActivitySuperAppStyles = (config: DesignSystem) => ({
    profileActivitySuperAppContainer: {
        background: neutralLayerCard,
        "margin-bottom": "16px",
        "box-shadow": "0px 0px 1px rgba(0, 0, 0, 0.05), 0px 0px 12px rgba(0, 0, 0, 0.08)",
        "border-radius": "6px",
        padding: "16px",
        "max-width": "75vw",
        width: "75vw",

        "& .cwt-name.cwt-link": {
            "font-weight": "normal"
        },

        "& .cwt-link": {
            "font-weight": "normal"
        },

        "& .cwt-body": {
            "& .cwt-show-clamped-btn": {
                background: isDarkMode(config) ?  "#343434" : "#f7f7f7"
            }
        },

        "&.new": {
            [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "0",
            "border-radius": "12px"
        },

        "& .cwt-start": {
            width: "32px",
            "justify-content": "center",
            "min-width": "32px",
            "& .cwt-avatar": {
                height: "32px",
                "min-width": "32px",
                width: "32px"
            }
        },

        "& .cwt-mid": {
            [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "12px",
            width: "100%",
            "& .cwt-text": {
                "& .cwt-body": {
                    background: isDarkMode(config) ?  "#343434" : "#f7f7f7",
                    margin: applyLocalizedProperty("12px 0 10px -12px", "12px -12px 10px 0", config.direction),
                    "& .cwt-name.cwt-link": {
                        color: isDarkMode(config) ? "#8AC9FF" :"#005599"
                    }
                }
            }
        },
        "& .cwt-end": {
            padding: "0"
        },
        ["&." + enums.responsiveLevels.L0]: {
            "max-width": "100%",
            width: "auto",
            "border-radius": "12px"
        }
    },

    profileActivityListSuperAppContainer: {
        padding: "16px",
        background: "transparent",
        display: "flex",
        "flex-direction": "column",
        "align-items": "center",
        ["&." + enums.responsiveLevels.L0]: {
            display: "block"
        }
    },

    profileActivityFollowSuperAppContainer: {
        "& .cwt-end": {
            "padding-left": "12px"
        }
    },
    profileActivityReactionSuperAppContainer: {},
    profileActivityReplySuperAppContainer: {}
});